"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { numberWithCommas } from "@/helpers/Helpers";
import { useIdentityActivity } from "@/hooks/useIdentityActivity";
import type { ReactNode } from "react";
import { buildUserPageBrainActivityViewModel } from "./userPageBrainActivity.helpers";
import { UserPageBrainActivityHeatmap, UserPageBrainActivityHeatmapLoading } from "./UserPageBrainActivityHeatmap";
import { getProfileWaveIdentity } from "./userPageBrainSidebar.helpers";
function ActivityCardFrame(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <section className="tw-relative tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/15 tw-bg-black tw-py-4 tw-shadow-2xl md:tw-py-5" aria-labelledby="brain-activity-heading" data-testid="brain-activity-card">{children}</section>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function ActivityCardHeader(t0) {
  const $ = _c(9);
  const {
    periodLabel,
    totalDrops
  } = t0;
  let t1;
  if ($[0] !== totalDrops) {
    t1 = totalDrops === 0 ? "0" : numberWithCommas(totalDrops);
    $[0] = totalDrops;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const totalDropsLabel = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-min-w-0"><h3 id="brain-activity-heading" className="tw-mb-0 tw-text-sm tw-font-bold tw-tracking-wide tw-text-iron-50">Activity</h3></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== periodLabel || $[4] !== totalDrops || $[5] !== totalDropsLabel) {
    t3 = periodLabel && totalDrops !== undefined && <div className="tw-text-xs tw-font-medium tw-text-iron-400 sm:tw-max-w-none sm:tw-text-right">{totalDropsLabel} public post{totalDrops === 1 ? "" : "s"} in {periodLabel}</div>;
    $[3] = periodLabel;
    $[4] = totalDrops;
    $[5] = totalDropsLabel;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="gap-x-4 tw-mb-4 tw-flex tw-flex-col tw-gap-y-2 tw-px-4 sm:tw-mb-6 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between md:tw-px-5">{t2}{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export default function UserPageBrainActivity(t0) {
  const $ = _c(18);
  const {
    profile
  } = t0;
  let t1;
  if ($[0] !== profile) {
    t1 = getProfileWaveIdentity(profile);
    $[0] = profile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const identity = t1;
  const t2 = identity.length > 0;
  let t3;
  if ($[2] !== identity || $[3] !== t2) {
    t3 = {
      identity,
      enabled: t2
    };
    $[2] = identity;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const activityQuery = useIdentityActivity(t3);
  if (!identity) {
    return null;
  }
  let t4;
  if ($[5] !== activityQuery.data) {
    t4 = activityQuery.data ? buildUserPageBrainActivityViewModel(activityQuery.data) : null;
    $[5] = activityQuery.data;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const activity = t4;
  const periodLabel = activity?.periodLabel;
  const totalDrops = activity?.totalDrops;
  let content;
  if (activityQuery.status === "pending") {
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <UserPageBrainActivityHeatmapLoading />;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    content = t5;
  } else {
    if (activityQuery.status === "error") {
      let t5;
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <p className="tw-px-4 tw-text-sm tw-text-iron-400 md:tw-px-5">Unable to load activity.</p>;
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      content = t5;
    } else {
      if (activity && activity.totalDrops > 0) {
        let t5;
        if ($[9] !== activity) {
          t5 = <UserPageBrainActivityHeatmap activity={activity} />;
          $[9] = activity;
          $[10] = t5;
        } else {
          t5 = $[10];
        }
        content = t5;
      } else {
        let t5;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <p className="tw-px-4 tw-text-sm tw-italic tw-text-iron-500 md:tw-px-5">No activity in last 12 months.</p>;
          $[11] = t5;
        } else {
          t5 = $[11];
        }
        content = t5;
      }
    }
  }
  let t5;
  if ($[12] !== periodLabel || $[13] !== totalDrops) {
    t5 = <ActivityCardHeader periodLabel={periodLabel} totalDrops={totalDrops} />;
    $[12] = periodLabel;
    $[13] = totalDrops;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== content || $[16] !== t5) {
    t6 = <ActivityCardFrame>{t5}{content}</ActivityCardFrame>;
    $[15] = content;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}